import { MappedResult } from '../mapped/index.mjs';
import { Extract } from './extract.mjs';
// prettier-ignore
function FromProperties(P, T) {
    return globalThis.Object.getOwnPropertyNames(P).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Extract(P[K2], T) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, T) {
    return FromProperties(R.properties, T);
}
// prettier-ignore
export function ExtractFromMappedResult(R, T) {
    const P = FromMappedResult(R, T);
    return MappedResult(P);
}
